<ng-container
  *ngrxLet="{
    companyName: companyName$,
    companyLogo: companyLogo$,
    loading: loading$,
    error: error$,
  } as vm">
  <div class="page-container">
    <div class="auth-container">
      <div class="auth-card">
        <div class="company-wrapper">
          <span class="company-label">Company</span>
          <span class="company-value" data-cy="integrations__company-name">{{ companyUser?.companyName }}</span>
          <p class="company-hint">
            Need to authorize a different company? Switch companies in Ninety, then start this authorization again.
          </p>
        </div>
        <div class="auth-header">
          <div class="brand-row">
            <div class="brand-pair">
              <img class="logo" src="/assets/login-bos/ninety/logo.svg" alt="Ninety Logo" />
              <terra-icon class="brand-bridge" icon="refresh" size="20" variant="fill"></terra-icon>
              <img class="logo" src="{{ vm.companyLogo }}" alt="Company Logo" />
            </div>
          </div>

          <h1 class="title">Authorize Integration</h1>
          <p class="subtitle">
            <span class="app-name">{{ vm.companyName }}</span> is requesting access to your Ninety account.
          </p>
        </div>

        <section class="panel scope-panel">
          <h2 class="panel-title">What access is {{ vm.companyName }} requesting?</h2>
          <p class="panel-lead">On Ninety.io, {{ vm.companyName }} will be able to:</p>
          <ul class="scope-list">
            <li>Create To-Dos, Measurables, Rocks, and Issues</li>
            <li>Read all To-Dos, Measurables, Rocks, and Issues</li>
            <li>Update existing To-Dos, Measurables, Rocks, and Issues</li>
            <li>Delete To-Dos, Measurables, Rocks, and Issues</li>
            <li>Manage Teams</li>
          </ul>
        </section>

        @if (!!vm.error && !vm.loading) {
          <section class="panel error-panel" aria-live="polite">
            <div class="error-header">
              <div class="error-title">Connection failed</div>
            </div>
            <p class="error-desc">
              Unable to establish a secure connection with
              <span class="app-name">{{ vm.companyName }}</span
              >. This might be due to network issues or temporary service unavailability.
            </p>
            <ul class="error-list">
              <li>Check your internet connection</li>
              <li>Try again in a few minutes</li>
              <li>
                Verify that <span class="app-name">{{ vm.companyName }}</span> services are operational
              </li>
            </ul>
          </section>
        }

        @if (!vm.error) {
          <section class="panel security-panel" role="note" aria-label="Security & Privacy">
            <div class="security-header">
              <terra-icon
                class="info-icon"
                icon="lock"
                size="20"
                variant="fill"
                ninetyPopoverOrigin
                data-product="learning-modules__sharing-tips-info-icon"></terra-icon>
              <div class="security-title">Security & Privacy</div>
            </div>
            <ul class="security-list">
              <li>{{ vm.companyName }} will only access data you explicitly authorize</li>
              <li>Your data remains secure and encrypted during all transfers</li>
              <li>{{ vm.companyName }} cannot access other parts of your Ninety.io account</li>
              <li>
                You maintain full control over your data and can revoke these permissions on your account by requesting
                through Ninety.io client support.
              </li>
            </ul>
          </section>
        }

        @if (errorMsg) {
          <section class="panel error-panel" role="alert" aria-live="assertive">
            <div class="error-header">
              <div class="error-title">Unable to authorize</div>
            </div>
            <p class="error-desc" data-cy="integrations__consent-error">{{ errorMsg }}</p>
          </section>
        }

        @if (!vm.error) {
          <div class="actions">
            <ninety-button
              data-cy="integrations__deny-button"
              dataProductPrimaryButton="integrations__deny-button"
              (click)="onDeny()"
              class="ghost-action"
              stroked>
              Cancel
            </ninety-button>
            <ninety-button
              data-cy="integrations_consent-button"
              dataProductPrimaryButton="integrations__consent-button"
              filled
              primary
              color="accent"
              class="primary-action"
              (click)="onConsent()">
              Authorize Integration
            </ninety-button>
          </div>
        } @else {
          <div class="actions actions--error">
            <ninety-button
              data-cy="integrations__deny-button"
              dataProductPrimaryButton="integrations__deny-button"
              (click)="onDeny()"
              class="ghost-action"
              stroked>
              Cancel
            </ninety-button>
            <ninety-button
              data-cy="integrations_consent-button"
              dataProductPrimaryButton="integrations__consent-button"
              filled
              primary
              color="accent"
              (click)="onConsent()">
              <terra-icon icon="refresh" />
              Try again
            </ninety-button>
          </div>
        }

        <p class="disclaimer">
          By clicking “Authorize Integration”, you agree to grant {{ vm.companyName || 'External Application' }} the
          selected permissions for your Ninety.io account.
        </p>
      </div>
    </div>
  </div>
</ng-container>
